import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Button } from 'reactstrap';
import { kebabCase } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { v4 as uuidV4 } from 'uuid';
import { appendPath } from '@truqc/content-path';
import AssetSelectionModal from './asset/assetSelectionModal';
import entityComposition from '../../common/classes/entityComposition';
import { enabledSelector, labelSelector, newPathSelector, valueSelector } from '../selectors';
import logValueOnChange from '../commonActions/logValueOnChange';
const AddAssetButton = _ref => {
  let _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled,
    title = _ref.title,
    onChange = _ref.onChange,
    path = _ref.path;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  const handleToggle = () => setOpen(!open);
  const handleAdd = useCallback(asset => {
    const associatedAsset = {
      asset,
      _created: moment().toISOString()
    };
    onChange({
      path: appendPath(path, uuidV4()),
      value: associatedAsset
    });
    setOpen(false);
  }, [onChange, path]);
  const buttonID = "".concat(kebabCase(title), "-add-btn");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    block: true,
    disabled: !enabled,
    id: buttonID,
    className: "pull-right t-aab-btn tqc-control"
  }, title), /*#__PURE__*/React.createElement(AssetSelectionModal, {
    isOpen: open,
    onSelect: handleAdd,
    onToggle: handleToggle,
    targetElementID: buttonID
  }));
};
AddAssetButton.propTypes = {
  enabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired
};
export { AddAssetButton as UncomposedAddAssetButton };
export default entityComposition(AddAssetButton, [], {
  enabled: enabledSelector,
  label: labelSelector,
  value: valueSelector,
  onChange: logValueOnChange,
  path: newPathSelector
});